export default __webpack_public_path__ + "static/media/stripe menu.5a6445da.png";